import { create } from "zustand";
import {
	SupervisorAgentsFilterState,
	SupervisorAgentsFilterActions,
} from "./types";
import { SupervisorAgentsFilterData } from "@/repository/models";
import { Availabilities } from "@/components/organisms/currentUserPresence/types";
import { getInitialSupervisorFilterData } from "@/common/helpers/supervisorHelper";

export const useSupervisorAgentsFilterStore = create<
	SupervisorAgentsFilterState & SupervisorAgentsFilterActions
>((set) => ({
	filterData: getInitialSupervisorFilterData(),
	setFilterData: (filterData: SupervisorAgentsFilterData) =>
		set({ filterData: filterData }),
	setQueueIds: (queueIds: string[]) =>
		set((state: SupervisorAgentsFilterState) => {
			const currentState = { ...state.filterData };
			currentState.queueIds = queueIds;

			return { filterData: currentState };
		}),
	setSearchText: (searchText: string) =>
		set((state: SupervisorAgentsFilterState) => {
			const currentState = { ...state.filterData };
			if (
				searchText.length > 2 ||
				(searchText.length === 0 && currentState.searchText.length !== 0)
			) {
				currentState.searchText = searchText;

				return { filterData: currentState };
			} else {
				return state;
			}
		}),
	setIsOnline: (isOnline: boolean | null) =>
		set((state: SupervisorAgentsFilterState) => {
			const currentState = { ...state.filterData };
			currentState.isOnline = isOnline;

			return { filterData: currentState };
		}),
	setHasClient: (hasClient: boolean | null) =>
		set((state: SupervisorAgentsFilterState) => {
			const currentState = { ...state.filterData };
			currentState.hasClient = hasClient;

			return { filterData: currentState };
		}),
	setIsJoined: (isJoined: boolean | null) =>
		set((state: SupervisorAgentsFilterState) => {
			const currentState = { ...state.filterData };
			currentState.isJoined = isJoined;

			return { filterData: currentState };
		}),
	setPresences: (presences: Availabilities[]) =>
		set((state: SupervisorAgentsFilterState) => {
			const currentState = { ...state.filterData };
			currentState.presences = presences;

			return { filterData: currentState };
		}),
	setDesire: (desire: number[]) =>
		set((state: SupervisorAgentsFilterState) => {
			const currentState = { ...state.filterData };
			currentState.desire = desire;

			return { filterData: currentState };
		}),
}));
